// extracted by mini-css-extract-plugin
export default {"wrapper":"Timmy_wrapper__03uE4","wrapperPriority":"Timmy_wrapperPriority__4CIwT","timmy":"Timmy_timmy__3s207","timmyDialog":"Timmy_timmyDialog__YdELf"};